import type { FirestoreTimestampLike } from "./types";

/** Converts Firestore timestamp variants to a Date. Falls back to `new Date()` for missing values. */
export function toDate(ts: FirestoreTimestampLike | undefined | null): Date {
    if (ts?.toDate) return ts.toDate();
    if (ts?._seconds) return new Date(ts._seconds * 1000);
    return new Date();
}
